import ThemePlaceholder from "components/Common/ThemePlaceholder"
import DocumentLayout from "./DocumentLayout"
import RecipientBlock from "./RecipientBlock"
import SubjectIntro from "./SubjectIntro"
import DetailRowsTable from "./DetailRowsTable"
import ClosingParagraphs from "./ClosingParagraphs"
import SignatoryFooter from "./SignatoryFooter"

const Line = ({ width = "100%", height = 12 }) => (
  <ThemePlaceholder width={width} height={height} />
)

const QuotationPreviewSkeleton = ({
  recipientLines = 4,
  detailRows = 6,
  closingParagraphs = 2,
}) => {
  const metaRows = [
    ["Ref", <Line key="ref" width="60%" />],
    ["Date", <Line key="date" width="50%" />],
    ["Valid Until", <Line key="valid" width="50%" />],
  ]

  const recipient = Array.from({ length: recipientLines }).map((_, i) => (
    <Line
      key={`recipient-${i}`}
      width={i === recipientLines - 1 ? "60%" : "80%"}
    />
  ))

  const rows = Array.from({ length: detailRows }).map((_, i) => [
    i + 1,
    <Line key={`label-${i}`} width="70%" />,
    <Line key={`value-${i}`} width="90%" />,
  ])

  const paragraphs = Array.from({ length: closingParagraphs }).map((_, i) => (
    <div key={`para-${i}`} className="pdf-mb-12">
      <Line width="100%" />
      <Line width="95%" />
      <Line width="70%" />
    </div>
  ))

  return (
    <DocumentLayout documentTitle="Loading…" metaRows={metaRows}>
      <RecipientBlock lines={recipient} />
      <SubjectIntro
        subject={<Line width="60%" />}
        intro=""
      />
      <DetailRowsTable rows={rows} />
      <ClosingParagraphs paragraphs={[]} />
      {paragraphs}
      <SignatoryFooter
        signatoryName={<Line width="40%" />}
        signatoryDesignation={<Line width="60%" />}
        acceptanceLabel={<Line width="70%" />}
      />
    </DocumentLayout>
  )
}

export default QuotationPreviewSkeleton
